import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import type {
  MarketRankEnded,
  MarketRankLive,
  PredictionMarketChoice,
  PredictionMarketWithProbability,
} from "@roman/shared/types/PredictionMarket";
import { PredictionMarketType, getPredictionMarketType } from "@roman/shared/utils/predictionMarket/utils";
import { ChoiceRanking } from "./ChoiceRanking";
import { SelectChoice } from "./SelectChoice";
import { YesNoTabs } from "./YesNoTab";

interface AllRankingsModalProps {
  isViewAllRankings: boolean;
  setIsViewAllRankings: (visible: boolean) => void;

  selectedChoice: PredictionMarketChoice | undefined;
  listChoices: PredictionMarketChoice[];
  setSelectedChoice: (choice: PredictionMarketChoice) => void;
  participantChoiceRanks: MarketRankLive["ranks"] | MarketRankEnded["ranks"];
  predictionMarket: PredictionMarketWithProbability;
}

export const AllRankingsModal = ({
  isViewAllRankings,
  setIsViewAllRankings,
  selectedChoice,
  listChoices,
  setSelectedChoice,
  participantChoiceRanks,
  predictionMarket,
}: AllRankingsModalProps) => {
  const marketType = getPredictionMarketType(predictionMarket.predictionMarketChoices);

  return (
    <Dialog open={isViewAllRankings} onOpenChange={setIsViewAllRankings}>
      <DialogContent className="[&>button]:hidden min-w-[360px] w-auto p-0 ring-0 ring-transparent">
        <div className="flex flex-col">
          <div className="bg-orange h-[71px] overflow-hidden rounded-tl-lg rounded-tr-lg flex items-center justify-center relative">
            <img className="w-[89px] h-[64px] top-[7px] left-[13px] absolute" src="/assets/YOSOMI.png" alt="YOSOMI" />
            <div className="text-white text-center text-[24px] font-bold leading-[35px]">全体のランキング</div>
            <div className="absolute top-[19px] right-[23.72px] bottom-[29.77px] w-8 h-6">
              <div className="relative">
                <img
                  src="/assets/BlingVector.png"
                  className="h-[11.232px] w-[9.415px] top-0 left-0 absolute"
                  alt="BlingVector"
                />
                <img
                  src="/assets/BlingVector.png"
                  className="h-[18.232px] w-[15.283px] right-0 top-1 absolute"
                  alt="BlingVector"
                />
              </div>
            </div>
          </div>

          <div className="h-[60vh] overflow-y-auto ml-2">
            <ChoiceRanking
              avatarSize="w-[30px] h-[30px]"
              titleFontSize="text-[12px]"
              isShowRankTitle={false}
              isShowUserNameTitle={false}
              participantChoiceRanks={participantChoiceRanks}
              slice={participantChoiceRanks.length}
            />
          </div>
          <div className="h-[72px] px-[10px] py-[11px]">
            {marketType === PredictionMarketType.MULTIPLE ? (
              <SelectChoice
                className="h-[50px]"
                selectedChoice={selectedChoice}
                listChoices={listChoices}
                setSelectedChoice={setSelectedChoice}
              />
            ) : (
              <div className="h-[50px]">
                <YesNoTabs
                  choices={listChoices}
                  selectedChoice={selectedChoice}
                  setSelectedChoice={setSelectedChoice}
                />
              </div>
            )}
          </div>

          <div className="mb-[21px] mt-[14px] mx-[30px] flex justify-center items-center">
            <Button
              className="text-base underline"
              variant="link"
              onClick={() => {
                setIsViewAllRankings(false);
              }}
            >
              閉じる
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
